import * as React from 'react';
import glamorous from 'glamorous';
import { Query } from 'react-apollo';
import { RvLoader } from '../../components/Loader';
import gql from 'graphql-tag';
import { GetGroupBy, GetGroupByPlurals, formatNumber, GetArrow, getSuggestedMaxTick, getMaxTickLimit, getLabels } from '../../helpers/ChartHelper';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { ChartCommonProps, IconButtonWrapper, ChartCommonState, HelpWrapper } from '../Common';
import { WithStyles, withStyles, IconButton } from '@material-ui/core';
import { styles } from '../styles';
import { ChartFilter } from '../ChartComponents';
import { SelectedItemProps } from '../MattersByStatusChart';
import { DrillDownType } from '../DrillDownType';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Scale,
    Tick,
    Chart,
    ChartEvent,
    ActiveElement,
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';
  
import { RV_CHART_CLASS, RV_CHART_COLORS, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartStatTiles } from '../ChartStatTiles';
import { ChartLimitNote } from '../ChartLimitNote';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
);

const BarWrapper = glamorous.div<{ theme?: object }>((props) => ({
    position: 'relative',
    paddingBottom: '10px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
    '@media print': {
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'center',
    }
}));

const BarTitleContainer = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '15px 15px 0px 15px',
    fontSize: '16px',
    fontWeight: 600,
    [`& .${`h1`}`]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`& .${`h2`}`]: {
        fontSize: '2.5rem',
        padding: '10px 0',
    },
    [`& .${`h3`}`]: {
        paddingTop: '10px'
    },
    '& .increase': {
        color: 'green',
    },
    '& .decrease': {
        color: 'red',
    }
})).withProps({ className: 'rv-chart-title-area' });

const BarContainer = glamorous.div<{ theme?: object }>((props) => ({
    padding: '5px 15px 15px 15px',
    minHeight: '300px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '350px',
    maxWidth: 'auto',
    position: 'relative',
    '@media (max-width: 533px)': {
        maxWidth: '350px',
        margin: '0 auto',
    },
    [`& .${`titleWrapper`}`]: {
        textAlign: 'center',
        display: 'inline-block',
        width: '100%',
        padding: '15px',
        [`& .${`title`}`]: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`value`}`]: {
            fontSize: '24px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`secondary-title`}`]: {
            fontSize: '16px',
            fontWeight: 400,
            display: 'block',
            marginBottom: '15px',
        }
    }
}));

const TotalDiv = glamorous.div<{ theme?: object }>((props) => ({
    cursor: 'pointer',
    paddingLeft: 5
}));

const LoadWrapper = glamorous.div<{ theme?: object }>((props) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));

interface ChartProps extends SelectedItemProps, ChartCommonProps, WithStyles<typeof styles> {
    periodInDays: number;
    groupBy: string;
    chartFilter?: ChartFilter;
}

interface ChartState extends ChartCommonState {
    // 
}

class MattersByPeriodChart extends React.Component<ChartProps, ChartState>  {

    // tslint:disable-next-line: no-any
    public chartRef: React.RefObject<any>;

    constructor(props: ChartProps, state: ChartState) {
        super(props, state);
        this.onCloseChart = this.onCloseChart.bind(this);
        this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
        this.handlePopoverClose = this.handlePopoverClose.bind(this);
        this.handleTotalClick = this.handleTotalClick.bind(this);
        this.chartRef = React.createRef();
        this.onPan = this.onPan.bind(this);
        this.onHover = this.onHover.bind(this);

        this.state = {
            open: false,
            anchorEl: undefined
        };
    }

    public componentDidMount() {
        // 
    }

    public componentWillUnmount() {
        // 
    }

    public shouldComponentUpdate(nextProps: ChartProps, nextState: ChartState): boolean {
        if (this.props !== nextProps || this.state !== nextState) {
           return true;
        }

        return false;
    }

    public render() {
        // const { classes } = this.props;
        var symbol = '';
        return (
            <React.Fragment>
                {/* tslint:disable-next-line: no-any */}
                 <Query<any> query={CurrencySymbol}>
                    {(result) => {

                        if (result.loading) {
                            return (
                                <ChartSkeleton variant="bars" />
                            );
                        }

                        const currencySymbol = (result.loading || result.error) ?
                            null : result.data.options.currencySymbol;

                        symbol = currencySymbol ? currencySymbol.symbol : null;
                        return(
                            // tslint:disable-next-line: no-any
                            <Query<any>
                                query={NewMattersByPeriodData}
                                variables={{
                                    periodInDays: this.props.periodInDays,
                                    groupBy: this.props.groupBy,
                                    entityType: this.props.chartFilter?.entityType,
                                    entityGuid: this.props.chartFilter?.entityGuid,
                                    responsibility: this.props.chartFilter?.responsibility
                                }}
                            >
                            {({ loading, error, data }) => {

                                if (loading) {
                                    return (
                                        <LoadWrapper className="load-wrapper">
                                            <RvLoader size="small" />
                                        </LoadWrapper>
                                    );
                                }

                                const statistics = data.statistics;

                                let matter = (loading || error ||
                                    statistics === null || statistics === undefined)
                                    ? null
                                    : statistics.matter;

                                let newMattersByPeriods = matter ?
                                    matter.newMattersByPeriods : null;

                                if (newMattersByPeriods && newMattersByPeriods.newMattersByPeriod) {
                        
                                    let currentPeriodTotalCount = newMattersByPeriods.currentPeriodTotalCount;
                                    let previousPeriodTotalCount = newMattersByPeriods.previousPeriodTotalCount;
                                    let labelCount = newMattersByPeriods.groupedByCount;
                                    // tslint:disable-next-line:no-any
                                    let labels = newMattersByPeriods.newMattersByPeriod.map((value: any) => { return value.groupedBy; });
                                    // tslint:disable-next-line:no-any
                                    let counts = newMattersByPeriods.newMattersByPeriod.map((value: any) => { 
                                        return value.count;
                                    });

                                    // tslint:disable-next-line: no-any
                                    let estimates = newMattersByPeriods.newMattersByPeriod.map((value: any) => { 
                                        return value.estimate;
                                    });

                                    return (
                                        <BarWrapper className={RV_CHART_CLASS}>
                                            <IconButtonWrapper
                                                aria-label="close"
                                            >
                                                 <HelpWrapper className="rv-chart-help">
                                                    <ChartInfo 
                                                        description={this.props.description}
                                                    />
                                                </HelpWrapper>
                                                <IconButton
                                                    aria-label="close"
                                                    onClick={this.onCloseChart}
                                                    size="small"
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </IconButtonWrapper>
                                            <BarTitleContainer>
                                                <ChartHeading icon={<AccessTimeOutlinedIcon />} title={<>New matters in the last {this.props.periodInDays} days</>} />
                                                <TotalDiv className="h2" onClick={() => this.handleTotalClick(true)}>
                                                    <AnimatedNumber value={currentPeriodTotalCount.count} format={(amount) => formatNumber(amount)} />
                                                    {GetArrow(currentPeriodTotalCount.count, previousPeriodTotalCount)}
                                                </TotalDiv>
                                                <div className="h3">
                                                    Previous Period 
                                                    <TotalDiv onClick={() => this.handleTotalClick(false)}>
                                                        {formatNumber(previousPeriodTotalCount)}
                                                    </TotalDiv>
                                                </div>
                                                <div className="h3 rv-chart-section">New Matters by {GetGroupBy(this.props.groupBy)}</div>
                                            </BarTitleContainer>
                                            <BarContainer className="rv-chart-bars">
                                                <Bar
                                                    ref={this.chartRef}
                                                    // tslint:disable-next-line: no-any
                                                    onClick={(event: React.MouseEvent<any>) => {
                                                        const _data = getElementAtEvent(this.chartRef.current, event);
                                                        if (_data.length > 0 && this.props.getSelectedItem) {

                                                            const _index = getElementAtEvent(this.chartRef.current, event)[0].index;

                                                            const item = labels[_index];

                                                            const searchCriterias = new Array<SearchCriteria>();

                                                            searchCriterias.push(
                                                                { property: this.props.groupBy, operator: 'eq', comparison: item },
                                                                // tslint:disable-next-line: max-line-length
                                                                { property: 'InstructionDateStartByPeriod', operator: 'gteq', comparison: this.props.periodInDays.toString() },
                                                                // tslint:disable-next-line: max-line-length
                                                                { property: 'InstructionDateEndByPeriod', operator: 'lteq', comparison: this.props.periodInDays.toString() }
                                                            );

                                                            this.props.getSelectedItem(
                                                                searchCriterias,
                                                                false,
                                                                // tslint:disable-next-line: max-line-length
                                                                `New matters in the last ${this.props.periodInDays} days by ${GetGroupBy(this.props.groupBy)}`,
                                                                DrillDownType.matterSummaryDrilldown,
                                                                'Matters'
                                                            );
                                                        }
                                                    }}
                                                    data={{
                                                        labels: getLabels(labels),
                                                        datasets: [
                                                            {
                                                                label: 'Matters',
                                                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                                                data: counts
                                                            }
                                                        ]
                                                    }}
                                                    options={{
                                                        onHover: this.onHover,
                                                        indexAxis: 'y' as const,
                                                        animation: rvChartAnimation(),
                                                        elements: { bar: { borderWidth: 0 } },
                                                        responsive: true,
                                                        maintainAspectRatio: false,
                                                        scales: {
                                                          x: {
                                                            grid: rvValueAxisStyle.grid,
                                                            // beginAtZero: true,
                                                            suggestedMax: getSuggestedMaxTick(counts),
                                                            beginAtZero: true,
                                                            ticks: {
                                                                ...rvValueAxisStyle.ticks,
                                                                maxTicksLimit: getMaxTickLimit(counts),
                                                                autoSkip: false,
                                                                callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                                                    return `${formatNumber(tickValue)}`;
                                                                }
                                                            }
                                                          },
                                                          y: {
                                                            grid: rvCategoryAxisStyle.grid,
                                                            // min: 0,
                                                            // max: 9 // minimum display
                                                            ticks: {
                                                                ...rvCategoryAxisStyle.ticks,
                                                                autoSkip: false
                                                            }
                                                          }
                                                        },
                                                        plugins: {
                                                          legend: {
                                                            position: 'bottom' as const,
                                                            display: false
                                                          },
                                                          title: {
                                                            display: false,
                                                            text: '',
                                                          },
                                                          zoom: {
                                                            pan: {
                                                              enabled: false,
                                                              onPan: this.onPan
                                                            },
                                                            zoom: {
                                                              wheel: {
                                                                enabled: false
                                                              }
                                                            }
                                                            // limits: {
                                                            //   y: { min: 0, max: 9 },
                                                            // },
                                                          },
                                                          tooltip: {
                                                            ...rvTooltipStyle,
                                                            callbacks: {
                                                                // tslint:disable-next-line: no-any
                                                                label: function (context: any) {
                                                                    const { 
                                                                        dataIndex, 
                                                                        //   label, 
                                                                        dataset,
                                                                        formattedValue 
                                                                    } = context;
                                                                    // console.log(label, dataIndex);
                                                                    // return `Billed Fees $${formattedValue}`;
                                                                    // tslint:disable-next-line: max-line-length
                                                                    var estimate = estimates[dataIndex];

                                                                    var estimateFeesLabel = `Estimated Fees ${symbol}${formatNumber(estimate)}`;

                                                                    return `${dataset.label} ${formattedValue}, ${estimateFeesLabel}`;
                                                                },
                                                            }
                                                          }
                                                        },
                                                    }}
                                                />
                                            </BarContainer>
                                            <ChartStatTiles
                                                caption="Estimates"
                                                tiles={[
                                                    { label: 'Total estimated fees', value: `${symbol}${formatNumber(currentPeriodTotalCount.totalEstimates)}`, color: RV_CHART_COLORS.green },
                                                    { label: 'Matters without estimate', value: formatNumber(currentPeriodTotalCount.mattersWithoutEstimate), color: RV_CHART_COLORS.amber },
                                                ]}
                                            />
                                            {
                                                labelCount > 10 ?
                                                    (<ChartLimitNote>The top 10 {GetGroupByPlurals(this.props.groupBy)} are shown</ChartLimitNote>) : undefined
                                            }
                                        </BarWrapper>
                                    );
                                }

                                return (
                                    <LoadWrapper className="load-wrapper">
                                        <RvLoader size="small" />
                                    </LoadWrapper>
                                );
                            }}
                            </Query>
                        );
                    }}
                </Query>
            </React.Fragment>
        );
    }

    private handleTotalClick(isCurrent: boolean) {
        if (this.props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push(
                { 
                    property: 'PeriodByDays', 
                    operator: 'eq', 
                    comparison: isCurrent ? 'curr' : 'prev', 
                    period: this.props.periodInDays.toString()
                }
            );
        
            this.props.getSelectedItem(
                searchCriterias,
                false,
                `New matters in the last ${this.props.periodInDays} days by ${GetGroupBy(this.props.groupBy)}`,
                DrillDownType.matterSummaryDrilldown,
                'Matters'
            );
        }        
    }

    private onCloseChart() {
        if (this.props.onCloseChart) {
            return this.props.onCloseChart(`isByPeriodChart${this.props.groupBy}${this.props.periodInDays}Open`);
        }
    }

    // tslint:disable-next-line: no-any
    private handlePopoverOpen(event: any) {
        this.setAnchorEl(event.currentTarget);
    }

    private handlePopoverClose = () => {
        this.setAnchorEl(null);
    }

    // tslint:disable-next-line: no-any
    private setAnchorEl(anchorElValue: any) {
        this.setState({
            anchorEl: anchorElValue,
            open: Boolean(anchorElValue)
        });
    }

    private onPan = (context: { chart: Chart }) => {
        this.chartRef.current.options.scales.x.min = 0;
        this.chartRef.current.update();
    }

    private onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    }
}

// tslint:disable-next-line: no-any
export default withStyles(styles as any, { withTheme: true })(MattersByPeriodChart as any) as any;

const CurrencySymbol = gql`query CurrencySymbol {
    options {currencySymbol {symbol}}
}`;

const NewMattersByPeriodData = gql`
query NewMattersByPeriodData($periodInDays: Int, $groupBy: MatterGroupBy,
                             $entityType: Int, $entityGuid: String, $responsibility: Int) {
    statistics {
        matter {
            newMattersByPeriods(periodInDays: $periodInDays, groupBy: $groupBy, 
                                entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                currentPeriodTotalCount{
                    count
                    mattersWithoutEstimate
                    totalEstimates
                }
                previousPeriodTotalCount
                groupedByCount
                newMattersByPeriod {
                    count
                    groupedBy
                    estimate
                }
            }
        }
    }
}`;